<canvas width="720" height="1280" style="width: 100%;" [id]="dynamicCanvasId"></canvas>